import {createSelector} from '@reduxjs/toolkit'

const eligibilityConfirmationSelector = createSelector(
    [state => state.components],
    ({eligibilityConfirmation}) => {
        return eligibilityConfirmation
    }
)

export const eligibilityConfirmationSelect = state => ({
    eligibilityConfirmation: eligibilityConfirmationSelector(state)
})
